import axios from "axios";

const API_URL = "https://backend.gouniquejourneys.co.uk/api"; // Backend URL

export const loginEmployee = async (employeeId, password) => {
  try {
    const response = await axios.post(`${API_URL}/auth/login`, { employeeId, password });
    return response.data; // Returns { token, user }
  } catch (error) {
    throw error.response?.data?.message || "Login failed";
  }
};

export const fetchProfile = async () => {
  try {
    const response = await axios.get(`${API_URL}/employee/profile`, {
      headers: {
        Authorization: `Bearer ${localStorage.getItem("token")}`,
      },
    });
    return response.data;
  } catch (error) {
    console.error("Error fetching dashboard stats:", error);
    throw error;
  }
};
